import { schema } from './schema.js';

function googlifyDate(date) {
	// dates are 'YYYYMMDD' strings in and for GA
	return date.toString().replace(/-/g, '');
}

const additional_config_info = {
	custom_map: {
		dimension1: 'Site Name',
		dimension2: 'Site Group',
		dimension3: 'External Source',
		dimension4: 'External Medium',
		dimension5: 'External Campaign',
		dimension6: 'External Content',
		dimension7: 'External Term',
		dimension8: 'Internal Source',
		dimension9: 'Internal Medium',
		dimension10: 'Internal Campaign',
		dimension11: 'Internal Content',
		dimension12: 'Internal Term',
		dimension13: 'Buyer',
		dimension14: 'Origin Code',
		dimension15: 'Internal Category',
		dimension16: 'Petition Sponsor',
		dimension17: 'Site Section', // aka pageCategory
		dimension18: 'Pagination',
		dimension19: 'Product Version Name',
		dimension20: 'Promo Name - Transaction-level',
		dimension21: 'Promo Name - Product-level',
		dimension22: 'Promo ID - Transaction-level',
		dimension23: 'Promo ID - Product-level',
		dimension24: 'Promo Code - Transaction-level',
		dimension25: 'Promo Code - Product-level',
		dimension26: 'Promo Type - Transaction-level',
		dimension27: 'Promo Type - Product-level',
		dimension28: 'SL Source',
		dimension29: 'SL Medium',
		dimension30: 'SL Campaign',
		dimension31: 'SL Content',
		dimension32: 'SL Term',
		dimension33: 'Writer ID', // writer ID eg '13941854-bcbe-49f8-b87c-a51c5982d3ae'
		dimension34: 'Landed Costs - Product-level',
		dimension35: 'Landed Costs - Transaction-level',
		dimension36: 'URL Handle',
		dimension37: 'Writer ID Rewrite',
		dimension38: 'Date Created', // date created eg '20190404'
		dimension39: 'Date Published', // eg '20190404'
		dimension40: 'Date Modified', // eg '20190404'
		dimension41: 'Author Name', // author (profile) name eg 'Sarah Cool'
		dimension42: 'Author ID', // author (profile) ID eg '323628'
		dimension43: 'Editor Name', // author (user) name eg 'Sarah Cool'
		dimension44: 'Editor ID', // author (user) ID eg '244'
		// dimension45: null,
		// dimension46: null,
		dimension47: 'client_id', // https://www.simoahava.com/analytics/add-clientid-to-custom-dimension-gtag-js/
		dimension48: 'GTM Tag Name',
	},
};

let custom_dimension_values = {
	...glp_site_options.analytics.dimensions,
};
if (document.body.dataset.single) {
	// we're an article and not an index page, so let's pass some additional info
	custom_dimension_values['Date Published'] = googlifyDate(
		schema.get('#article', 'datePublished') ||
			schema.get('#webpage', 'datePublished')
	); // eg '20190404' (from '2019-04-04')
	custom_dimension_values['Date Modified'] = googlifyDate(
		schema.get('#article', 'dateModified') ||
			schema.get('#webpage', 'dateModified')
	); // eg '20190404' (from '2019-04-04')
	// we have anonymized our Persons with hashes, so if all we want is a name it's easier to get it from attributes
	custom_dimension_values['Author Name'] = document.body.dataset.authorname; // author (user) name eg 'American Web Media'
	custom_dimension_values['Editor Name'] = document.body.dataset.editorname; // author (user) name eg 'Sarah Cool'
}

window.dataLayer = window.dataLayer || [];
export function gtag() {
	window.dataLayer.push(arguments);
}

gtag('set', custom_dimension_values);
gtag('js', new Date());
gtag('config', glp_site_options.analytics.property, additional_config_info);
